import moment from 'moment'
moment.locale('es-do')

export function dateFormat (value, format) {
  if (!value) {
    return 'N/A'
  }

  return moment(value, 'YYYY-MM-DD h:mm:ss').format(format)
}

export function currency (value) {
  if (!value) {
    return
  }

  const result = parseFloat(value).toFixed(0).replace('.', ',')
  return '$ ' + result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
